import React, { useEffect } from 'react';
import styles from 'assets/css/CourseComponent.module.css';
import ScheduleCoursePartials from 'Components/Card/Partials/Partials.ScheduleCourse';
import scheduleCourseHelpers from 'Components/Card/helper/scheduleCourseHelpers';
import CoursePartials from 'Components/Card/Partials/Partials.Course';
import useAttention from 'context/AttentionContext';
import { getUTCDateFromServerDate } from 'utils/dateUtils';
import imagesPath, { getImageSource } from 'utils/imgUtils';

/*
[Display States]:
1) not scheduled
2) scheduled
3) [possibly?] audit
4) completed
*/

/*
[Required Props]
Shared
- HeaderText
- SubHeaderText
- HasCourse --> scheduled : not scheduled
- HasUpcomingClass

State: Not Scheduled
- "Schedule Now Display"
- VoucherExpirationDate
- Schedule Now Button

State: Scheduled
- EventDateTime
- EventEnd
- EventOrganizerDisplay
- Event Button (open course, launch class)

State: Completed
- "Completed Date Display"
- Open Course Btn
*/

function ScheduleCourseComponent(props) {
    const { 
        course, 
        welcomeMessageTitle, 
        wrapperModifierClass, 
        courseImg 
    } = props;
    const { clearAttentionState, setAttentionWarning } = useAttention();

    let courseImgResolved = courseImg ? courseImg : getImageSource(course.CourseImageUrl);
    let wrapperModifierClassResolved = wrapperModifierClass ? wrapperModifierClass : course.WrapperModifierClass;
    let welcomeMessageTitleResolved = welcomeMessageTitle ? welcomeMessageTitle : course.WelcomeMessageTitle;

    const showWelcome = welcomeMessageTitle && !course.HasCourse;
    const { 
        showVoucher, 
        showEvent, 
        showAudit, 
        showComplete,
        showIncomplete, 
        showProgress
    } = scheduleCourseHelpers.getShowProperties(course);

    useEffect(() => {
        if (showVoucher || showAudit) {
            setAttentionWarning();
        } else {
            clearAttentionState();
        }
    }, [showVoucher, showAudit, setAttentionWarning, clearAttentionState]);

    return (
        <div className={`${styles.wrapper} ${styles[wrapperModifierClassResolved]}`}>
            {courseImgResolved && <div className={styles.imgWrap}>
                <img src={courseImgResolved} alt={course.HeaderText} />
            </div>}
            <div className={styles.contentWrap}>
                <h4 className={styles.courseHeader}>{course.HeaderText}</h4>
                <h4 className={styles.courseSubtitle}>{course.SubHeaderText}</h4>
                {showWelcome && <CoursePartials.Welcome welcomeMessageTitle={welcomeMessageTitleResolved} />}
                {showProgress && <CoursePartials.Progress {...course} />}
                {showVoucher && <ScheduleCoursePartials.VoucherContent voucherExpirationDate={getUTCDateFromServerDate(course.VoucherExpirationDate)} />}
                {showEvent && <ScheduleCoursePartials.ScheduleCourseEventDisplay {...props} />}
                {showAudit && <ScheduleCoursePartials.AuditContent />}
                {<CoursePartials.BodyCopy bodyStateCopy={course.BodyStateCopy} />}
                {showComplete && <ScheduleCoursePartials.CompleteContent completionDate={getUTCDateFromServerDate(course.CompletionDate)} />}
                {!course.HasUpcomingClass &&  <ScheduleCoursePartials.CardLink {...course} />}
                {showEvent && <ScheduleCoursePartials.CourseLaunchBtn {...props} />}
            </div>
        </div>
    )
}

export default ScheduleCourseComponent;